<script>
import Mixin from "@utilities/mixin";
import StoreSelect from "@components/settings/StoreSelect.vue";

export default {
  mixins: [Mixin],
  components: {loginStoreSelect: StoreSelect},
  data() {
    const loggedInUser = sessionStorage.getItem('sbUserId');
    const currentShop = sessionStorage.getItem('sbShopId');
    return {
      isRegistered: Boolean(loggedInUser && currentShop)
    }
  },
  computed: {
    shops() {
      return this.$store.state.shops;
    },
    techs() {
      return this.$store.state.techs;
    },
    currentShop() {
      const currentShopId = JSON.parse(sessionStorage.getItem('sbShopId'));
      return this.shops.find(s => s.id === currentShopId);
    },
    currentUser() {
      return this.$store.state.user
    },
    allUsers() {
      return this.$store.state.users
    }
  },
  methods: {
    setReg(isRegistered) {
      this.isRegistered = isRegistered;
    },
    deregister() {
      sessionStorage.removeItem('sbUserId');
      sessionStorage.removeItem('sbShopId');
      this.isRegistered = false;
    }
  },
  created() {
    this.getCurrentUser();
    this.getAllUsers();
    this.getTechs();
    this.getShops();
    this.$store.commit('setCurrentShopID', JSON.parse(sessionStorage.getItem('sbShopId')))
  }
}
</script>

<!--No semantic title tags due to elementor styling overrides-->
<!--When the page styles are deactivated, reinstate-->

<template>
  <Toolbar class="mb-0 w-full" style="background-color: #025F53">
    <template #start>
      <span class="my-0 text-3xl me-6 text-white font-bold">SMOG BUDDY</span>
      <Button as="router-link" to="/" class="nav-btn me-2" label="Docs"/>
      <Button as="router-link" to="/services" class="nav-btn me-2" label="Services"/>
      <Button as="router-link" to="/reports" class="nav-btn me-2" label="Reports"/>
    </template>
    <template #end>
      <div class="flex gap-6 items-center">
      <span class="m-0 font-extralight text-white"
            v-if="isRegistered && currentShop && user">{{ user.data ? user.data.display_name : '' }} at
        {{ currentShop.name }}</span>
        <span class="m-0 text-white" v-else>Not signed in!</span>
        <Button v-if="isRegistered" @click="deregister" class="nav-btn" label="Switch Shop"/>
        <login-store-select @check="setReg" v-else></login-store-select>
      </div>
    </template>
  </Toolbar>
</template>

<style scoped>

.nav-btn:hover {
  background-color: #03C4AA;
}

</style>